'use strict';

module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/var/Inflections.js
// module id = 110
// module chunks = 0